// extracted by mini-css-extract-plugin
export var checkboxInputRow = "v_sc";
export var checkboxInputColumn = "v_sd";
export var inputOptionRow = "v_r5";
export var inputOptionColumn = "v_r6";